import Content from './content-interface';

export default class SetInstanceActivatedHistory implements Content {
  instance: string;

  constructor(obj: any = {}) {
    this.instance = obj.instance || '';
  }

  public static of(obj: any = {}): SetInstanceActivatedHistory {
    return new SetInstanceActivatedHistory(obj);
  }
}
